import { object, number } from 'yup';

export const carFetchParamsSchema = object({
  carId: number(),
  manufacturedYear: number(),
});
